import { render, staticRenderFns } from "./company_profile.vue?vue&type=template&id=1a76afd1&scoped=true&"
import script from "./company_profile.vue?vue&type=script&lang=js&"
export * from "./company_profile.vue?vue&type=script&lang=js&"
import style0 from "./company_profile.vue?vue&type=style&index=0&id=1a76afd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a76afd1",
  null
  
)

export default component.exports